import { call, put, takeLatest } from "redux-saga/effects";
import { API_ENDPOINTS } from "../../../../util/constants";
import {
  createHeadersWithAuth,
  createQueryString,
  requestPromise
} from "../../../../util/request";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";
import {
  fetchCallStatusDataSuccess,
  FETCH_CALL_STATUS
} from "../actions/callStatusActions";

function* getCallStatusData(action) {
  let requestURL = API_ENDPOINTS.getCallConnectivity;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  yield put(
    actions.setLoadingState({
      resource: "call_status_today",
      loading_state: "loading",
    })
  );
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(fetchCallStatusDataSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "call_status_today",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}
export default function* callStatusSaga() {
  yield takeLatest(FETCH_CALL_STATUS, getCallStatusData);
}
